import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import React from "react";

// ── react-datepicker global CSS overrides (MUI-aligned) ───────────────────────

export const customDatePickerStyles = `
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    width: 100%;
  }
  .react-datepicker {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    border: none;
    border-radius: 4px;
    box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2),
                0px 8px 10px 1px rgba(0,0,0,0.14),
                0px 3px 14px 2px rgba(0,0,0,0.12);
  }
  .react-datepicker__header {
    background-color: #fff;
    border-bottom: none;
    padding-top: 15px;
  }
  .react-datepicker__current-month {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
  }
  .react-datepicker__day-name {
    color: rgba(0, 0, 0, 0.6);
  }
  .react-datepicker__day {
    color: rgba(0, 0, 0, 0.87);
  }
  .react-datepicker__day:hover {
    background-color: rgba(63, 80, 181, 0.04);
    border-radius: 50%;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: #3f50b5 !important;
    color: #fff !important;
    border-radius: 50%;
  }
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end {
    background-color: #3f50b5 !important;
    color: #fff !important;
    border-radius: 50%;
  }
  .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
    background-color: rgba(63, 80, 181, 0.08) !important;
    color: #3f50b5 !important;
    border-radius: 0;
  }
  .react-datepicker__navigation-icon::before {
    border-color: rgba(0, 0, 0, 0.54);
  }
  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker-popper {
    z-index: 2000 !important;
  }
`;

// ── MUI TextField wrapper ─────────────────────────────────────────────────────

export const TextInput: any = styled(TextField)`
  & .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input {
    cursor: ${({ $readOnly }: any) => ($readOnly ? "not-allowed" : "text")};
  }
`;

// ── YearSelectHeader inline styles ────────────────────────────────────────────

export const headerWrapperStyle: React.CSSProperties = {
  position: "relative",
};

export const headerRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 12px",
  gap: "8px",
};

// Simple text-only arrow button — no border, no background
export const navButtonStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: 20,
  lineHeight: 1,
  padding: "2px 6px",
  color: "rgba(0,0,0,0.54)",
  borderRadius: 4,
  transition: "color 0.15s",
};

// Clickable "March 2026" label with a subtle chevron SVG
export const headerLabelStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 600,
  color: "rgba(0,0,0,0.87)",
  padding: "4px 8px",
  borderRadius: 4,
  display: "flex",
  alignItems: "center",
  gap: 4,
  transition: "background 0.15s",
};

export const yearGridContainerStyle: React.CSSProperties = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  zIndex: 1000,
  background: "#fff",
  border: "1px solid #e0e0e0",
  borderRadius: 8,
  boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
  maxHeight: 220,
  overflowY: "auto",
  padding: 8,
};

export const yearGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 4,
};

export const yearButtonStyle: React.CSSProperties = {
  background: "none",
  border: "1px solid transparent",
  borderRadius: 6,
  cursor: "pointer",
  fontSize: 13,
  padding: "6px 4px",
  textAlign: "center",
  transition: "all 0.15s",
  color: "rgba(0,0,0,0.87)",
};

export const yearButtonActiveStyle: React.CSSProperties = {
  background: "#3f50b5",
  color: "#fff",
  borderColor: "#3f50b5",
  fontWeight: 700,
};